export const contact =  {
    "email": "hahuang@scrippscollege.edu",
    "tel": "908-607-3266",
    "fax": "909-607-9170"
};